import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  SimpleGrid,
  Stack,
  Text,
} from '@chakra-ui/react';
import * as React from 'react';

interface CorporateEnrollmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onYesClick: () => void;
  onNoClick: () => void;
}

export const CorporateEnrollmentModal: React.FC<
  CorporateEnrollmentModalProps
> = ({ isOpen, onClose, onYesClick, onNoClick }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent maxW="640px" borderRadius="2xl">
        <ModalHeader pt="6">
          <Text fontSize="lg" fontWeight="semibold">
            Does your organization already have a membership?
          </Text>
          <Text fontSize="sm" color="gray.600" fontWeight="normal" mt="2">
            Your organization may already have corporate membership available to
            employees
          </Text>
        </ModalHeader>
        <ModalBody pb="6" pt="4">
          <SimpleGrid columns={{ base: 1, md: 2 }} spacing="4" mt="4" mb="4">
            <Button
              type="button"
              onClick={onYesClick}
              w="100%"
              minH="180px"
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="2xl"
              bg="white"
              textAlign="left"
              p="6"
              cursor="pointer"
              transition="all 0.2s"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              alignItems="stretch"
              _hover={{ bg: 'blue.50', shadow: 'md' }}
              _focus={{ boxShadow: 'outline' }}
              variant="unstyled"
            >
              <Stack spacing="3" align="flex-start" h="full" justify="space-between">
                <Box>
                  <Text fontWeight="semibold" fontSize="lg" mb="2">
                    Yes
                  </Text>
                  <Text
                    fontSize="sm"
                    color="gray.600"
                    lineHeight="tall"
                    whiteSpace="normal"
                    overflowWrap="break-word"
                  >
                    Check whether your employer or organization sponsors a
                    company-paid membership.
                  </Text>
                </Box>
              </Stack>
            </Button>

            <Button
              type="button"
              onClick={onNoClick}
              w="100%"
              minH="180px"
              borderWidth="1px"
              borderColor="gray.200"
              borderRadius="2xl"
              bg="white"
              textAlign="left"
              p="6"
              cursor="pointer"
              transition="all 0.2s"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
              alignItems="stretch"
              _hover={{ bg: 'blue.50', shadow: 'md' }}
              _focus={{ boxShadow: 'outline' }}
              variant="unstyled"
            >
              <Stack spacing="3" align="flex-start" h="full" justify="space-between">
                <Box>
                  <Text fontWeight="semibold" fontSize="lg" mb="2">
                    No
                  </Text>
                  <Text
                    fontSize="sm"
                    color="gray.600"
                    lineHeight="tall"
                    whiteSpace="normal"
                    overflowWrap="break-word"
                  >
                    Continue to the standard list of memberships you can purchase
                    individually.
                  </Text>
                </Box>
              </Stack>
            </Button>
          </SimpleGrid>

        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
